module.exports = __webpack_public_path__ + "static/media/federationuni.45c6bb0a.png";